import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  return {
    dialogContent: {
      '& .MuiPaper-root': {
        overflowY: 'auto',
        ...theme.scrollbarStyles
      }
    },
    // =========================================================================
    // ## Estrutura Principal e Layout
    // =========================================================================
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    boxTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    boxTitleText: {
      color: theme.palette.blue_300.main
    },
    boxStepper: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px'
    },
    boxStepperContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px'
    },
    stepLabel: {
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: '14px',
      transition: 'all 0.3s ease'
    },
    stepFromToStep: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      fontWeight: 500,
      whiteSpace: 'nowrap',
      fontSize: '.875rem'
    },
    contentTitle: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      '& h2': {
        margin: 0,
        color: theme.palette.blue_300.main
      },
      '& span': {
        color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
      }
    },

    // =========================================================================
    // ## Formulários e Departamentos
    // =========================================================================
    boxMenuDepartment: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '8px 16px !important',
      borderRadius: '16px',
      border: `1px solid ${theme.palette.blue_300.main}`,
      backgroundColor: theme.palette.blue_300.main + '1A'
    },
    contentMenuDepartment: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      color: theme.palette.blue_300.main,
      '& h3': { margin: 0 }
    },
    boxForm: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '8px',
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      borderRadius: 16,
      padding: '8px 16px',
      marginBottom: '16px'
    },

    // =========================================================================
    // ## Opções e Cards Clicáveis (Passo 1)
    // =========================================================================
    buttonBase: {
      width: '100%',
      textAlign: 'left',
      display: 'block',
      borderRadius: '12px',
      padding: '16px',
      transition: 'all 0.2s ease-in-out'
    },
    chipMenuOption: {
      height: '24px',
      fontSize: '.7rem',
      fontWeight: 'bold',
      backgroundColor: theme.palette.green_300.main,
      color: theme.palette.green_200.main,
      margin: '0 0 10px 0',
      '& svg': { color: theme.palette.green_200.main }
    },
    chipMenuDepartment: {
      height: '24px',
      fontSize: '.7rem',
      fontWeight: 'bold',
      backgroundColor: theme.palette.blue_50.main,
      color: theme.palette.blue_300.main,
      margin: '0 0 10px 0',
      '& svg': { color: theme.palette.blue_300.main }
    },
    boxHelp: {
      display: 'flex',
      gap: '8px',
      backgroundColor: isDark
        ? theme.palette.dark_700.main
        : theme.palette.white_100.main
    },
    helpTitleText: {
      display: 'flex',
      gap: '8px',
      fontSize: '1rem',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    titleFlow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
      fontWeight: '600'
    },
    helpText: {
      margin: '8px 0',
      fontSize: '.875rem',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      '& div': { margin: '2px 0 8px' }
    },
    boxExample: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '4px 16px',
      borderRadius: 8,
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
      margin: '0 0 10px 0',
      color: theme.palette.blue_300.main,
      '& svg': { color: theme.palette.blue_300.main }
    },
    contentExample: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },
    boxDepartmentExample: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '8px',
      padding: '4px 16px',
      borderRadius: 8,
      border: isDark
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`
    },
    separator: {
      height: '2px',
      width: '50px',
      backgroundColor: theme.palette.blue_300.main
    },

    // =========================================================================
    // ## Listas e Itens (Subdepartamentos)
    // =========================================================================
    boxList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    list: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '4px 16px',
      border: `1px solid ${
        isDark
          ? theme.palette.dark_stroke?.main
          : theme.palette.gray_stroke?.main || '#e0e0e0'
      }`,
      borderRadius: '8px',
      backgroundColor: theme.palette.background.paper
    },
    circle: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: theme.palette.blue_300.main,
      display: 'inline-block',
      marginRight: 8
    },
    textList: {
      fontWeight: 600,
      color: theme.palette.blue_300.main
    },
    textAttendants: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main
    },

    // =========================================================================
    // ## Anexos (Attachments) e Pré-visualização
    // =========================================================================
    attachmentContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    buttonsAttachmentFile: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      width: '100%',
      height: '90px',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
      border: isDark
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
      borderRadius: '8px',
      padding: '16px'
    },
    buttonsBoxAttachment: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px'
    },
    buttonsAttachment: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '8px'
    },
    attachmentPreviewImage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 100,
      maxHeight: 100,
      padding: '8px',
      objectFit: 'contain',
      borderRadius: '8px',
      height: 'auto'
    },
    attachmentNotFile: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      fontStyle: 'italic'
    },
    boxContainerAttachmentAndActions: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'space-between',
      gap: '8px'
    },

    // =========================================================================
    // ## Botões e Ações
    // =========================================================================
    actionButtonsForm: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px'
    },
    boxActionsButtons: {
      display: 'flex'
    },
    buttonFile: {
      '& .MuiButton-label': {
        display: 'flex',
        gap: '8px'
      },
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      height: 35,
      borderRadius: 8,
      maxWidth: 250,
      '&:hover': {
        backgroundColor: theme.palette.green_200.main
      },
      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    },
    contentActionsButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    iconButtonEdit: {
      border: 0,
      padding: '0',
      backgroundColor: 'transparent',
      '&:hover': { backgroundColor: 'transparent' },
      '& svg': { color: theme.palette.blue_300.main }
    },
    iconButtonDelete: {
      border: 0,
      padding: '0',
      backgroundColor: 'transparent',
      '&:hover': { backgroundColor: 'transparent' },
      '& svg': { color: theme.palette.red_100.main }
    },
    deleteButton: {
      color: theme.palette.red_100.main,
      height: 35,
      width: 50,
      borderRadius: 8,
      '&:hover': {
        backgroundColor: theme.palette.red_100.main,
        color: theme.palette.white_100.main
      }
    },

    // =========================================================================
    // ## Diálogos / Modais
    // =========================================================================
    dialogTitleActiveOption: {
      color: `${theme.palette.blue_300.main} !important`,
      '& svg': { color: `${theme.palette.blue_300.main} !important` }
    },
    dialogActions: {
      padding: '12px 24px'
    },
    dialogContentPreview: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden'
    },
    imagePreview: {
      maxWidth: '100%',
      maxHeight: '50vh',
      objectFit: 'contain'
    },

    // =========================================================================
    // ## Passo Final: Resumo da Edição/Criação
    // =========================================================================
    boxSummary: {
      backgroundColor: isDark
        ? theme.palette.dark_800.main
        : theme.palette.gray_100.main,
      padding: '24px',
      borderRadius: '8px',
      marginTop: '16px'
    },
    boxSummaryContent: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      backgroundColor:
        theme.palette.type === 'dark' ? 'rgba(43, 117, 211, 0.08)' : '#f0f6fc',
      border: `1px solid ${theme.palette.blue_300?.main}`,
      borderRadius: '8px',
      padding: '10px',
      marginBottom: '12px'
    },
    boxSummarySubdepartments: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: '8px'
    },
    summaryTitle: {
      fontWeight: '600',
      color: theme.palette.blue_300.main,
      marginBottom: '8px'
    },
    boxSubdepartments: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: isDark
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main,
      border: `1px solid ${
        theme.palette.type === 'dark'
          ? theme.palette.dark_stroke?.main
          : theme.palette.gray_stroke?.main
      }`,
      borderRadius: '8px',
      padding: '8px 12px'
    },
    boxSubdepartmentsTitle: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px' // Atualizado para 8px seguindo a mesma estrutura do item da lista
    },
    roundedName: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: theme.palette.blue_300?.main,
      color: theme.palette.white_100.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      fontSize: '18px'
    },
    menuName: {
      fontWeight: 700,
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      lineHeight: 1.2
    },
    menuDescription: {
      color: isDark ? theme.palette.dark_50.main : theme.palette.gray_400.main,
      lineHeight: 1.2
    }
  }
})
